// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K-XE","content":"styles_content__2Z5Kw","row":"styles_row__1fH2T","footer":"styles_footer__3CB5V","phraseLength":"styles_phraseLength__2I-DJ"};